module.exports = __webpack_public_path__ + "static/media/taco.f4fafbd0.svg";